import { render, staticRenderFns } from "./quotation_preview.vue?vue&type=template&id=28330777&scoped=true&"
import script from "./quotation_preview.vue?vue&type=script&lang=js&"
export * from "./quotation_preview.vue?vue&type=script&lang=js&"
import style0 from "./quotation_preview.vue?vue&type=style&index=0&id=28330777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28330777",
  null
  
)

export default component.exports